import { Theme } from '@mui/material';
import MCardContent, { CardContentProps as MCardContentProps } from '@mui/material/CardContent';
import React, { forwardRef } from 'react';

type CardContentProps = MCardContentProps;

const CardContent = forwardRef<HTMLDivElement, CardContentProps>((props, ref) => {
  return (
    <MCardContent
      ref={ref}
      {...props}
      sx={[
        (theme: Theme) => ({
          backgroundColor: theme.palette.background.paper,
          p: '10px 20px 10px 20px',
          borderRadius: `${theme.borderRadius.lg}px`,
          boxShadow: theme.customShadows.cardContent,
          height: '100%',
        }),
        props.sx as object,
      ]}
    />
  );
});

export default React.memo(CardContent);
